import type { BackendTypes } from '@tf/api';

import constate from 'constate';
import type React from 'react';
import { useState } from 'react';

interface MenuItem {
	status: BackendTypes.FieldValidationStatus;
	label: string;
	isSelected: boolean;
	onClick: () => void;
	type?: 'form' | 'connection';
}

const [MenuStateProvider, useMenuState] = constate((props: { value: MenuItem[] }) => {
	const [menuItems, setMenuItems] = useState<MenuItem[]>(props.value);

	return { menuItems, setMenuItems };
});

export const useMenu = useMenuState;

export const MenuProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
	return <MenuStateProvider value={[]}>{children}</MenuStateProvider>;
};
